module.exports = __webpack_public_path__ + "img/quicktips32.b7e89b6f.svg";